<template>
    <v-dialog
        :value="isOpen"
        scrollable
        max-width="450px"
        transition="slide-y-transition"
        eager
        :persistent="actionLoading"
        @keydown.esc="onClose"
        @click:outside="onClose"
    >
        <v-card>
            <v-card-title>
                <h1 class="text-subtitle-1">
                    Wybierz proces źródłowy do skopiowania
                </h1>
            </v-card-title>
            <v-card-text class="pb-0">
                <v-row>
                    <v-col cols="12">
                        <v-select
                            v-model="selectedTaskId"
                            :items="filteredTasks"
                            item-value="id"
                            no-data-text="Nie znaleziono procesów"
                            outlined
                            dense
                            required
                        >
                            <template slot="selection" slot-scope="data">
                                {{ taskLabel(data.item) }}
                            </template>
                            <template slot="item" slot-scope="data">
                                {{ taskLabel(data.item) }}
                            </template>
                        </v-select>
                    </v-col>
                </v-row>
            </v-card-text>

            <v-divider />

            <v-card-actions>
                <v-btn
                    color="error"
                    text
                    :disabled="actionLoading"
                    data-sentry-label="Anuluj"
                    @click="onClose"
                >
                    Anuluj
                </v-btn>
                <v-spacer />
                <v-btn
                    color="success"
                    text
                    :loading="actionLoading"
                    :disabled="!selectedTaskId"
                    data-sentry-label="Zapisz"
                    @click="onSave"
                >
                    Zapisz
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: 'CopyTaskParametersDialog',
    props: {
        isOpen: {
            type: Boolean
        },
        targetTaskId: {
            type: Number,
            default: null
        },
        tasksData: {
            type: Array,
            default: () => []
        },
        actionLoading: {
            type: Boolean
        }
    },
    data() {
        return {
            selectedTaskId: null
        }
    },
    computed: {
        targetProcessId() {
            const target = this.tasksData.find(task => task.id === this.targetTaskId)

            return target ? target.processId : null
        },
        filteredTasks() {
            return this.tasksData.filter(
                task => task.id !== this.targetTaskId && task.processId === this.targetProcessId
            )
        }
    },
    watch: {
        isOpen(boolean) {
            if (!boolean) {
                setTimeout(() => {
                    this.selectedTaskId = null
                }, 500)
            }
        }
    },
    methods: {
        taskLabel(task) {
            if (!task || !task.process) return ''

            return `#${task.id} ${task.process.name}`
        },
        onSave() {
            this.$emit('on-save', this.selectedTaskId, this.targetTaskId)
        },
        onClose() {
            if (!this.actionLoading) {
                this.$emit('on-close')
            }
        }
    }
}
</script>
